module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/pink-56669f92891465d4301a97e0597dc07a.png";